import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Spinner } from "flowbite-react";
import { API_BASE_URL } from "../../../config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiMenu, FiX, FiArrowLeft } from "react-icons/fi";
import CloverPayment from "./CloverPayment"; // 📌 Integración con Clover

const Ofertas = () => {
  const [ofertas, setOfertas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cuponSeleccionado, setCuponSeleccionado] = useState(null);
  const [merchantId, setMerchantId] = useState("");
  const [message, setMessage] = useState("");

const cliente_id = searchParams.get("menu") || localStorage.getItem("cliente_id");

useEffect(() => {
    const fetchOfertas = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/cupones`);
            if (!response.ok) {
                throw new Error("Error al obtener las ofertas");
            }

            const data = await response.json();
            if (!Array.isArray(data)) {
                throw new Error("Formato de datos incorrecto en ofertas");
            }

            // Filtrar ofertas según cliente_id
            const ofertasFiltradas = data.filter(oferta => oferta.cliente_id === Number(cliente_id));

            console.log("✅ Ofertas obtenidas para cliente_id:", cliente_id, ofertasFiltradas);
            setOfertas(ofertasFiltradas);
        } catch (err) {
            console.error("❌ Error al obtener ofertas:", err.message);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchMerchantId = async () => {
        try {
            if (!cliente_id) {
                throw new Error("cliente_id no definido. No se puede obtener Merchant ID.");
            }

            const response = await fetch(`${API_BASE_URL}/clientes/${cliente_id}/merchant`);
            if (!response.ok) {
                throw new Error("Error al obtener Merchant ID");
            }

            const data = await response.json();
            if (!data.merchant_id) {
                throw new Error("merchant_id no encontrado en la respuesta.");
            }

            console.log("✅ Merchant ID obtenido:", data.merchant_id);
            setMerchantId(data.merchant_id);
        } catch (err) {
            console.error("❌ Error al obtener Merchant ID:", err.message);
            setError(err.message);
        }
    };

    if (cliente_id) {
        setLoading(true);
        fetchOfertas();
        fetchMerchantId();
    } else {
        console.warn("⚠️ No se ejecutaron fetchOfertas y fetchMerchantId porque cliente_id es inválido.");
    }
}, [cliente_id]);

const handleOpenModal = (cupon) => {
    if (!merchantId) {
      setError("❌ No se pudo obtener el Merchant ID. Intenta nuevamente.");
      return;
    }
    setCuponSeleccionado(cupon);
    setShowModal(true);
    setMessage("");
  };

  const calcularTiempoRestante = (fechaExpiracion) => {
    const expiracion = new Date(fechaExpiracion);
    const ahora = new Date();
    const diferencia = expiracion - ahora;

    if (diferencia <= 0) {
      return "Expirado";
    }

    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    return `${dias} días, ${horas} horas restantes`;
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={() => setSidebarOpen(false)}></div>}
      
      <div className={`fixed top-0 left-0 h-screen w-64 bg-white shadow-2xl z-50 transition-transform overflow-y-auto ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 md:relative`}>
        <button onClick={() => setSidebarOpen(false)} className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 md:hidden"><FiX size={28} /></button>
        <nav className="p-4">
          <ul className="space-y-2">
            <li><a href={`/usuario/cuenta?menu=${cliente_id}`} className="block p-3 rounded-lg bg-gray-50 hover:bg-gray-200">Cuenta</a></li>
            <li><a href={`/usuario/ofertas?menu=${cliente_id}`} className="block p-3 rounded-lg bg-gray-50 hover:bg-gray-200">Ofertas</a></li>
            <li><a href="/usuario/restaurantes" className="block p-3 rounded-lg bg-gray-50 hover:bg-gray-200">Restaurantes</a></li>
          </ul>
        </nav>
        <div className="p-4">
          <Button gradientDuoTone="purpleToPink" onClick={() => navigate(`/menu/${cliente_id}`)}>
            <FiArrowLeft className="mr-2" /> Volver al Menú
          </Button>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <button onClick={() => setSidebarOpen(true)} className="absolute top-4 left-4 text-gray-800 text-2xl md:hidden focus:outline-none"><FiMenu /></button>
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Ofertas Disponibles</h1>
        {loading && <p className="text-blue-500">Cargando ofertas...</p>}
        {error && <p className="text-red-500">{error}</p>}

        <div className="w-full max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ofertas.map((oferta) => (
            <Card key={oferta.codigo} className="w-full shadow-lg">
              <img src={oferta.imagen_url.startsWith("http") ? oferta.imagen_url : `${API_BASE_URL}/${oferta.imagen_url}`} alt={oferta.titulo} className="h-48 w-full object-cover rounded-t-lg" />
              <div className="p-4">
                <h3 className="text-xl font-semibold">{oferta.titulo}</h3>
                <p className="text-gray-700">{oferta.descripcion}</p>
                <p className="text-green-600 font-bold">Descuento: {oferta.descuento}%</p>
                <p className="text-gray-500 text-sm">Expira en: {calcularTiempoRestante(oferta.fecha_expiracion)}</p>
                <Button className="mt-2 w-full text-lg font-bold" onClick={() => handleOpenModal(oferta)}>Comprar</Button>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <Modal.Header>Confirmar Compra</Modal.Header>
        <Modal.Body>
          {cuponSeleccionado && (
            <>
              <p className="text-xl font-bold">
              Total a pagar: <span className="text-green-600">${(parseFloat(cuponSeleccionado?.precio || 0) + 5).toFixed(2)}</span>
              </p>
              <p className="text-gray-500">Incluye un fee de prosecamiento y servicio de $5.00.</p>
              <p className="text-sm text-gray-600">Paga de forma segura con Clover.</p>

              {/* 🔹 Integración de CloverPayment */}
              <CloverPayment 
                cupon={cuponSeleccionado}
                merchantId={merchantId}
                onSuccess={() => {
                  setMessage("✅ Pago procesado correctamente. Revisa tu correo.");
                  setShowModal(false);
                }}
              />
            </>
          )}
          {message && <p className="text-green-500 font-bold text-center">{message}</p>}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Ofertas;
